if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    $('[data-fancybox]').fancybox({
        loop : true
    });

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    $(document).ready(function () {
        $('.slick-dots li button').append('<div class="circle"><svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38"><circle cx="19" cy="19" r="17.5"/></svg></div>');
    });


    $('.sym-slides').slick({
        accessibility: false,
        prevArrow: '<button type="button" class="slick-prev"><span class="icon"><svg xmlns="http://www.w3.org/2000/svg" width="27.07" height="12.24" viewBox="0 0 27.07 12.24"><path d="M1.94,5.64A7.21,7.21,0,0,0,7.58,0l1,.24A8.18,8.18,0,0,1,4.67,5.62h21.4V2.12h1v8h-1V6.62H4.67A8.21,8.21,0,0,1,8.55,12l-1,.24A7.2,7.2,0,0,0,1.94,6.61L0,6.12Z"/></svg></span><span class="text">Prev</span></button>',
        nextArrow: '<button type="button" class="slick-next"><span class="text">Next</span><span class="icon"><svg xmlns="http://www.w3.org/2000/svg" width="27.07" height="12.24" viewBox="0 0 27.07 12.24"><path d="M25.13,5.64A7.19,7.19,0,0,1,19.49,0l-1,.24A8.15,8.15,0,0,0,22.4,5.62H1V2.12H0v8H1V6.62H22.4A8.17,8.17,0,0,0,18.52,12l1,.24a7.18,7.18,0,0,1,5.64-5.63l1.94-.49Z"/></svg></span></button>'
    });

    $('.images-slides').slick({
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 500,
        fade: true,
        accessibility: true
    });

    $('.slider-info-slides').slick({
        arrows: true,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 700,
        fade: true,
        prevArrow: '<button type="button" class="slick-prev"><span class="icon"><svg xmlns="http://www.w3.org/2000/svg" width="27.07" height="12.24" viewBox="0 0 27.07 12.24"><path d="M1.94,5.64A7.21,7.21,0,0,0,7.58,0l1,.24A8.18,8.18,0,0,1,4.67,5.62h21.4V2.12h1v8h-1V6.62H4.67A8.21,8.21,0,0,1,8.55,12l-1,.24A7.2,7.2,0,0,0,1.94,6.61L0,6.12Z"/></svg></span><span class="text">Prev</span></button>',
        nextArrow: '<button type="button" class="slick-next"><span class="text">Next</span><span class="icon"><svg xmlns="http://www.w3.org/2000/svg" width="27.07" height="12.24" viewBox="0 0 27.07 12.24"><path d="M25.13,5.64A7.19,7.19,0,0,1,19.49,0l-1,.24A8.15,8.15,0,0,0,22.4,5.62H1V2.12H0v8H1V6.62H22.4A8.17,8.17,0,0,0,18.52,12l1,.24a7.18,7.18,0,0,1,5.64-5.63l1.94-.49Z"/></svg></span></button>',
        accessibility: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    autoplay: false,
                }
            }
        ]
    });

    $('.reviews-slides').slick({
        arrows: true,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 500,
        fade: true,
        prevArrow: '<button type="button" class="slick-prev"><span class="icon"><svg xmlns="http://www.w3.org/2000/svg" width="27.07" height="12.24" viewBox="0 0 27.07 12.24"><path d="M1.94,5.64A7.21,7.21,0,0,0,7.58,0l1,.24A8.18,8.18,0,0,1,4.67,5.62h21.4V2.12h1v8h-1V6.62H4.67A8.21,8.21,0,0,1,8.55,12l-1,.24A7.2,7.2,0,0,0,1.94,6.61L0,6.12Z"/></svg></span><span class="text">Prev</span></button>',
        nextArrow: '<button type="button" class="slick-next"><span class="text">Next</span><span class="icon"><svg xmlns="http://www.w3.org/2000/svg" width="27.07" height="12.24" viewBox="0 0 27.07 12.24"><path d="M25.13,5.64A7.19,7.19,0,0,1,19.49,0l-1,.24A8.15,8.15,0,0,0,22.4,5.62H1V2.12H0v8H1V6.62H22.4A8.17,8.17,0,0,0,18.52,12l1,.24a7.18,7.18,0,0,1,5.64-5.63l1.94-.49Z"/></svg></span></button>',
        accessibility: true,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    arrows: false,
                }
            }
        ]
    });

    $('.gallery-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        prevArrow: '<button type="button" class="slick-prev"><span class="icon"><svg xmlns="http://www.w3.org/2000/svg" width="27.07" height="12.24" viewBox="0 0 27.07 12.24"><path d="M1.94,5.64A7.21,7.21,0,0,0,7.58,0l1,.24A8.18,8.18,0,0,1,4.67,5.62h21.4V2.12h1v8h-1V6.62H4.67A8.21,8.21,0,0,1,8.55,12l-1,.24A7.2,7.2,0,0,0,1.94,6.61L0,6.12Z"/></svg></span><span class="text">Prev</span></button>',
        nextArrow: '<button type="button" class="slick-next"><span class="text">Next</span><span class="icon"><svg xmlns="http://www.w3.org/2000/svg" width="27.07" height="12.24" viewBox="0 0 27.07 12.24"><path d="M25.13,5.64A7.19,7.19,0,0,1,19.49,0l-1,.24A8.15,8.15,0,0,0,22.4,5.62H1V2.12H0v8H1V6.62H22.4A8.17,8.17,0,0,0,18.52,12l1,.24a7.18,7.18,0,0,1,5.64-5.63l1.94-.49Z"/></svg></span></button>',
        accessibility: true,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    //FAQ
    setTimeout(function(){
        $('.tab-label').each(function(){
            let thisHeightTap = $(this).height() + 40;
            let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
            $(this).parent().animate({height: thisHeightTap + 'px'},200);
            if($(this).hasClass('open')){
                $(this).parent().animate({height: thisHeight + 'px'},400);
            }
        });
    }, 400);

    $('.tab-label').click(function(){
        let currentclick = $(this);
        let thisHeightTap = $(this).height() + 40;

        let slideIndex = $(this).data('artwork');
        $(".accordion-slide").slick('slickGoTo', parseInt(slideIndex));

        if(!currentclick.hasClass('open')){
            $('.tab-label').each(function(){
                if($(this) !== currentclick ){
                    if($(this).hasClass('open')){
                        let thisHeight = $(this).height() + 40;
                        $(this).removeClass('open');
                        $(this).parent().animate({height: thisHeight + 'px'},400);
                    }
                }
            });
            currentclick.addClass('open');
            let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
            $(this).parent().animate({height: thisHeight + 'px'},400);
        } else {
            currentclick.removeClass('open');
            currentclick.parent().animate({height: thisHeightTap + 'px'},400);
        }
    });

})();

function animateto(target){
    var gotoTarget = offset(document.getElementById(target)).top - 130;
    var from     = window.pageYOffset
    var to       = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

/** Video functionality with keyboard **/

document.addEventListener('DOMContentLoaded', function() {
    const btnVideo = document.getElementById('btn_video');
    const videoContainer = document.querySelector('.video-container');
    const video = document.getElementById('video');

    btnVideo.addEventListener('click', function() {
        videoContainer.style.display = 'block';
        video.play();
        video.requestFullscreen();
        video.focus();
    });

    video.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
            video.pause();
            videoContainer.style.display = 'none';
            document.exitFullscreen();
            btnVideo.focus();
        } else if (event.key === ' ' || event.key === 'Enter') {
            event.preventDefault();
            video.paused ? video.play() : video.pause();
        }
    });

    document.addEventListener('fullscreenchange', function() {
        if (!document.fullscreenElement) {
            video.pause();
            videoContainer.style.display = 'none';
            btnVideo.focus();
        }
    });
});

